import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { botTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const REMOVE_BOT_PAGE_TOAST = 'remove-bot-page';

export const removeBotPage = ({ _id }: botTypes.RemovePageData): Promise<void> => {
  return axios.delete(`/bot/pages/${_id}`);
};

type UseRemoveBotPageOptions = {
  config?: MutationConfig<typeof removeBotPage>;
};

export function useRemoveBotPage({ config = {} }: UseRemoveBotPageOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (variables) => {
      toasts.loadingToast.loading(REMOVE_BOT_PAGE_TOAST, 'Removing page...');
      return config.onMutate?.(variables);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['bot-pages']);
      toasts.loadingToast.success(REMOVE_BOT_PAGE_TOAST, 'Page removed successfully');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(REMOVE_BOT_PAGE_TOAST, serverMessage);
      config.onError?.(error, variables, context);
    },
    mutationFn: removeBotPage,
  });
}
